import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Sidebar } from '@/client/components/layout/sidebar';
import { TopBar } from '@/client/components/layout/topbar';
import { supabase } from '@/client/lib/supabase';
import { trpcVanilla } from '@/client/utils/trpc-client';

export const Route = createFileRoute('/_app')({
  beforeLoad: async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session) throw redirect({ to: '/login' });
  },
  loader: async () => {
    const { needsOnboarding } = await trpcVanilla.user.needsOnboarding.query();
    if (needsOnboarding) throw redirect({ to: '/onboarding' });
  },
  staleTime: Number.POSITIVE_INFINITY,
  component: AppLayout,
});

function AppLayout() {
  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <TopBar />
        <main id="main-content" className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
